module.exports = new __parcel__URL__("sw_feed_background.7493f32c.png").toString();